import { render, staticRenderFns } from "./machinePreviewItem.vue?vue&type=template&id=485071fe&scoped=true&"
import script from "./machinePreviewItem.vue?vue&type=script&lang=js&"
export * from "./machinePreviewItem.vue?vue&type=script&lang=js&"
import style0 from "./machinePreviewItem.vue?vue&type=style&index=0&id=485071fe&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "485071fe",
  null
  
)

export default component.exports